import React, { useState } from "react";
import "./Home.css";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import WhyUsSection from "../Home/WhyUs/WhyUs";
import WhatsAppIcon from "../../WhatsAppComponent/WhatsAppIcon";
import OurPartners from "./OurPartners/OurPartners";
import ProductsPreview from "../Products/OurProducts";
import Footer from "../Footer/Footer";

const Home = () => {
  const [showMainContent, setShowMainContent] = useState(false);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });

    const timer = setTimeout(() => {
      setShowMainContent(true);
      localStorage.setItem("showMainContent", "true");
    }, 4000);

    return () => clearTimeout(timer);
  }, []);

  if (!showMainContent) {
    return (
      <div className="buffer-video-container">
        <video src="/BufferVideo(2).mp4" autoPlay muted className="buffer-video" />
      </div>
    );
  }

  return (
    <div className="main-wrapper">
      <div className="homepage-video-container">
        <video
          src={"/HomePageVideo(1).mp4"}
          autoPlay
          loop
          muted
          className="homepage-video"
        />
        <div className="video-overlay">
          <h1>Engineered Cutting Technology</h1>
        </div>
        <div className="mouse-icon">
          <div className="mouse">
            <div className="scroll"></div>
          </div>
        </div>
      </div>

      <div className="company-profile-section">
        <div className="left-box" data-aos="fade-right">
          <span className="bracket">[</span>
          <span className="text">14 Years of Working Experience</span>
          <span className="bracket">]</span>
        </div>

        <div className="middle" data-aos="zoom-in">
          <h2 style={{ color: "#6495ED" }}>Leading Brand in the Cutting Industry</h2>
        </div>

        <div className="right" data-aos="fade-left">
          <p>
            <strong className="highlight">CUTTECH Solutions</strong> is a
            leading brand in the cutting tools industry, founded by Keerthisagar
            A. M and co-founded by Mr. Srinivas Govindaiah. Established in 2022,
            CUTTECH Solutions represents the strategic merger of Simple
            Mechanical Solutions, consolidating their expertise and legacy into
            a single powerhouse. The brand specializes in delivering
            high-precision cutting tools and machining solutions for diverse
            industries, including Automotive, Aerospace, Defense, and General
            Engineering.
          </p>
        </div>
      </div>
      <div className="our-products">
        <ProductsPreview />
      </div>
      <div className="products-profile-section" data-aos="zoom-in">
        <div className="left-image">
          <img
            src="/CUTTECH Tap Catalog_250719_225509PDF_250719_225611.jpg"
            alt="Tools"
          />
        </div>

        <div className="right-text">
          <h2>Create. Collaborate. Innovate.</h2>
          <p>Build powerful mechanical solutions tailored to your needs.</p>
          <ul className="features-list">
            <li>High-performance cutting tools for milling and turning</li>
            <li>Precision tooling solutions for maximum efficiency</li>
            <li>Engineered coatings to extend tool life</li>
            <li>Global support and technical expertise</li>
          </ul>

          <div className="action-buttons">
            <a href="/Cuttech-catalog.pdf" download>
              <button className="catalog-btn">📥 Download Catalog</button>
            </a>

            <a
              href="https://wa.me/917019444941?text=Hi, I'm interested in collaborating with your team."
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="whatsapp-btn">🤝 Start Collaboration</button>
            </a>
          </div>
        </div>
      </div>
      <div className="our-partners">
        <OurPartners />
      </div>

      <div className="why-us-section" style={{ backgroundColor: "#f8f8f8" }}>
        <WhyUsSection />
      </div>
      <div className="footer-section" style={{ backgroundColor: "#f8f8f8" }}>
        <Footer />
      </div>
      <WhatsAppIcon />
    </div>
  );
};

export default Home;
